import wrapper from 'wrapper';
import Scrolly from '../scrolly-library/scrolly';
import events from '../scrolly-library/events-emitter';
/* eslint-disable no-console */

class Scroller {
    constructor(visualisation) {
        this.scrolly = new Scrolly({
            step: '.step',
            graphic: '.scroll__graphic',
            container: '.scroll__container',
            textContainer: '.scroll__text',
            offset: 0.33, // number between 0 and 1, defaults to 0.5
            debug: false, // defaults to false
        });
        this.visualisation = visualisation;
        this.animated = true;
        if (this.animated) {
            wrapper.select('canvas').classList.add('animated');
        }

        this.gregariousLocust = wrapper.select('#gregarious');

        this.scrollyConfig = {
            scrollDown: [
                () => {
                    this.fadeLocust('locust', 'gregarious');
                    wrapper.select('.chart-title-container').style.display = 'none';
                },
                () => {
                    this.locustToDot();
                    setTimeout(() => {
                        this.visualisation.update('smallNumberOfLocusts');
                    }, 300);
                },
                () => {
                    this.visualisation.update('allTheLocusts');
                    wrapper.select('.chart-title-container').style.display = 'block';
                },
                () => {
                    this.visualisation.update('chartOfLocusts');
                    setTimeout(() => {
                        wrapper.select('canvas').classList.add('transparent');
                        wrapper.selectAll('.fade-chart').forEach((el) => {
                            el.classList.remove('transparent');
                        });
                    }, this.animated ? 2500 : 0);
                },
            ],
            scrollUp: [
                () => {
                    this.fadeLocust('gregarious', 'locust');
                },
                () => {
                    this.dotToLocust();
                },
                () => {
                    this.visualisation.update('smallNumberOfLocustsFlyAway');
                },
                () => {
                    wrapper.select('canvas').classList.remove('transparent');
                    wrapper.selectAll('.fade-chart').forEach((el) => {
                        el.classList.add('transparent');
                    });
                    setTimeout(() => {
                        this.visualisation.update('allTheLocusts');
                    }, this.animated ? 1000 : 0);
                },
            ],
        };

        // set up scroller events/callbacks
        events.on('step-enter', (interaction) => {
            this.handleStepEnter(interaction);
        });

        events.on('animation-toggled', (target) => {
            this.animated = target;
        });
    }

    handleStepEnter(interaction) {
        if (interaction.currentDirection === 'down' && interaction.index > 0) {
            this.scrollyConfig.scrollDown[interaction.index - 1]();
        }
        if (interaction.currentDirection === 'up' && interaction.index < this.scrollyConfig.scrollUp.length) {
            this.scrollyConfig.scrollUp[interaction.index]();
        }
    }

    fadeLocust(fromType, toType) {
        if (wrapper.select('.transition-to-dot')) wrapper.select('.transition-to-dot').classList.remove('transition-to-dot');
        if (wrapper.select('.transition-from-dot')) wrapper.select('.transition-from-dot').classList.remove('transition-from-dot');
        wrapper.select(`#${fromType}`).classList.add('transparent');
        wrapper.select(`#${toType}`).classList.remove('transparent');
    }

    locustToDot() {
        if (this.animated) {
            this.gregariousLocust.classList.add('transition-to-dot');
            this.gregariousLocust.classList.remove('transition-from-dot');
        }
        else {
            this.gregariousLocust.classList.add('transparent');
        }
        wrapper.select('canvas').style.display = 'block';
    }

    dotToLocust() {
        if (this.animated) {
            this.gregariousLocust.classList.remove('transition-to-dot');
            this.gregariousLocust.classList.add('transition-from-dot');
            setTimeout(() => {
                if (wrapper.select('.transition-from-dot')) wrapper.select('.transition-from-dot').classList.remove('transition-from-dot');
            }, 1000);
        }
        else {
            this.gregariousLocust.classList.remove('transparent');
        }
        wrapper.select('canvas').style.display = 'none';
        this.visualisation.stopAnimationLoop();
    }
}

export default Scroller;
